import React, { useState } from "react";
import { Tooltip, Button, Icon, Modal, Select } from "antd";
import { connect } from "dva";
import ListPage from "../../../../../../components/ListPage";
import { GetQueryString } from "../../../../../../utils/utils";
import { url } from "../../../../../../services/service-utils";
import tableColumns from "./tableColumns";
import useRequest from "../../hooks/use-table-state";
import styles from "./index.less";

const { ListTable } = ListPage;

const downloadUrl = {
  schoolStuClass: "exportSchDeptStu",
  schoolStuPersonal: "exportSchPerStu",
  schoolStuSchool: "exportSchSchStu",
  schoolTeaPersonal: "exportSchPerTea",
  bureauStuClass: "exportEduDeptStu",
  bureauStuPersonal: "exportEduPerStu",
  bureauStuSchool: "exportEduOrgStu",
  bureauTeaSchool: "exportEduSchTea",
  bureauTeaPersonal: "exportEduPerTea"
};
const PointRankList = props => {
  const appId = GetQueryString("appId") || 40;
  const activityBizId = GetQueryString("activityBizId");
  const {
    modalVisible,
    nowRadioValue,
    orgType,
    request,
    nowRankType,
    classList,
    haveClassList
  } = props;

  const [nowDeptId, setNowDeptId] = useState(
    haveClassList && classList && classList[0] && classList[0].id
  );

  const {
    pageInfo,
    list,
    loading,
    handlePaginationChange,
    handleQueryChange
  } = useRequest(request, {
    initParams: haveClassList
      ? {
          page: 1,
          pageSize: 10,
          activityBizId,
          deptId: classList && classList[0] && classList[0].id
        }
      : {
          page: 1,
          pageSize: 10,
          activityBizId
        }
  });

  const handleShowModal = visible => {
    const { handleShowModal: handleModalVisible } = props;
    if (handleModalVisible) {
      handleModalVisible(visible);
    }
  };

  const handleClassChange = value => {
    setNowDeptId(value);
    handleQueryChange({ query: { deptId: value } });
  };

  const columns = tableColumns[nowRankType];

  const renderRulesModal = () => {
    const modalProps = {
      visible: modalVisible,
      width: 680,
      footer: null,
      title: "积分规则说明",
      className: "pointRankListModalContainer",
      onCancel: () => handleShowModal(false)
    };
    return (
      <Modal {...modalProps}>
        <div className="modalBodyContainer">
          <div className="title">
            活动期间内，跟进活动参与人的发布打卡、互动（点赞、评论）进行积分排序。
          </div>
          <div className="rulesContainer">
            <div className="rulesContentItem">
              <div className="rulesTitle">1、积分规则：</div>
              <div className="rulesDataContent">
                <div className="rulesItem">
                  <span>个人总积分=</span>
                  当日完成打卡(5分)+被点赞(0.1分)
                  +被评论(0.15分)+为他人点赞(0.05分)+为他人评论(0.1分）
                </div>
                {nowRadioValue === "student" && (
                  <div className="rulesItem">
                    <span>班级平均积分=</span>
                    班级已参与学生总积分/本班需参与学生总数
                  </div>
                )}
                {nowRadioValue === "student" && (
                  <div className="rulesItem">
                    <span>学校总积分=</span>
                    本校已参与学生总积分/本校需参与学生总数
                  </div>
                )}
                {nowRadioValue === "teacher" && orgType === 'county' && (
                  <div className="rulesItem">
                    <span>学校总积分=</span>
                    学校已参与教师总积分/学校需参与教师总数
                  </div>
                )}
              </div>
            </div>
            <div className="rulesContentItem">
              <div className="rulesTitle">2、统计说明：</div>
              <div className="rulesDataContent rulesDataContentNoDot">
                <div className="rulesItem">
                  <span>同一活动，完成打卡，积分仅计5次/日；</span>
                </div>
                <div className="rulesItem">
                  <span>
                    同一用户，为他人点赞/被他人点赞，单日积分分别最多计100次/日；
                  </span>
                </div>
                <div className="rulesItem">
                  <span>
                    同一用户，为他人评论/被他人评论，单日积分分别最多计50次/日；
                  </span>
                </div>
              </div>
            </div>
            <div className="rulesContentItem">
              <div className="rulesTitle">3、更新时间：</div>
              <div className="contentText">
                排序每日凌晨更新一次，活动结束后结束统计。
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  };

  const listPageProps = {
    spinProps: {
      spinning: loading
    }
  };

  const tableProps = {
    columns,
    list,
    pageInfo,
    onPageChange: handlePaginationChange
  };

  return (
    <div className={styles.root}>
      <ListPage {...listPageProps}>
        {haveClassList && classList?.length && (
          <div>
            <Select
              style={{ width: 260 }}
              defaultValue={classList[0]?.id}
              onChange={handleClassChange}
            >
              {classList &&
                classList.length &&
                classList.map(item => (
                  <Select.Option value={item.id}>{item.name}</Select.Option>
                ))}
            </Select>
          </div>
        )}
        <div className="rankRules">
          <span className="rankTip" onClick={() => handleShowModal(true)}>
            积分规则说明
            <Icon type="right" style={{ color: "#1785EC" }} />
          </span>
          <span className="updateTime">
            更新时间:{(list && list[0] && list[0].updateTime) || "-"}
            <Button
              type="primary"
              href={
                haveClassList
                  ? `${url.activitySign}/leaderboard/download/${downloadUrl[nowRankType]}/${activityBizId}/${nowDeptId}?appId=${appId}`
                  : `${url.activitySign}/leaderboard/download/${downloadUrl[nowRankType]}/${activityBizId}?appId=${appId}`
              }
              style={{
                marginLeft: 16
              }}
            >
              导出
            </Button>
          </span>
        </div>
        <ListTable {...tableProps} />
      </ListPage>
      {renderRulesModal()}
    </div>
  );
};

export default connect(({ activityGlobal }) => ({
  classList: activityGlobal.classList
}))(PointRankList);
